/*
 * TransferForm Messages
 *
 * This contains all the text for the TransferForm component.
 */

import { defineMessages } from 'react-intl';

export const scope =
  'src.pages.ProjectDetailsPage.components.JobDetails.components.TransferForm';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Standby Transfer',
  },
  transferButton: {
    id: `${scope}.transferButton`,
    defaultMessage: 'Transfer Selected',
  },
  confirmLabel: {
    id: `${scope}.confirmLabel`,
    defaultMessage: 'Confirm',
  },
  jobIdLabel: {
    id: `${scope}.jobIdLabel`,
    defaultMessage: 'Target Job ID*',
  },
  jobTitleLabel: {
    id: `${scope}.jobTitleLabel`,
    defaultMessage: 'Job Title',
  },
  projectIdLabel: {
    id: `${scope}.projectIdLabel`,
    defaultMessage: 'Target Project ID',
  },
  projectNameLabel: {
    id: `${scope}.projectNameLabel`,
    defaultMessage: 'Project Name',
  },
  transferableMessage: {
    id: `${scope}.transferableMessage`,
    defaultMessage:
      "Student's standby shifts are not covering all shifts of the selected target job.",
  },
  targetJobNotFound: {
    id: `${scope}.targetJobNotFound`,
    defaultMessage: '(target job not found)',
  },
  atLeastOneShiftRequired: {
    id: `${scope}.atLeastOneShiftRequired`,
    defaultMessage: 'At least one shift must be selected',
  },
});
